const getLabel = (
    quantity: number,
    showSuffix: boolean,
    translations: Map<string, string>
): string => {
    if (quantity === 0) {
        return translations.get('studio') || '';
    }
    if (quantity === 1) {
        const suffix = ` ${translations.get('bed')}`;
        return `1${showSuffix ? suffix : ''}`;
    }
    const suffix = ` ${translations.get('beds')}`;
    return `${quantity}${showSuffix ? suffix : ''}`;
};

const isSelected = (value: number) => {
    return !isNaN(value);
};

const getMinMax = (
    bedsMinInt: number,
    bedsMaxInt: number,
    translations: Map<string, string>
) => {
    if (isSelected(bedsMinInt) && !isSelected(bedsMaxInt)) {
        return ` ${translations.get('min')}`;
    }
    if (!isSelected(bedsMinInt) && isSelected(bedsMaxInt)) {
        return ` ${translations.get('max')}`;
    }
    return '';
};

export const buildSelectBedsTitle = (
    bedsMinInt: number,
    bedsMaxInt: number,
    translations: Map<string, string>
): string => {
    if (!isSelected(bedsMinInt) && !isSelected(bedsMaxInt)) {
        return translations.get('default') || '';
    }
    if (bedsMinInt === 0 && bedsMaxInt === 0) {
        return translations.get('studios') || '';
    }

    const bedsMin = isSelected(bedsMinInt)
        ? getLabel(bedsMinInt, !isSelected(bedsMaxInt), translations)
        : '';
    const separator =
        isSelected(bedsMaxInt) && isSelected(bedsMinInt) ? ' - ' : '';
    const bedsMax = isSelected(bedsMaxInt)
        ? getLabel(bedsMaxInt, true, translations)
        : '';
    const minMax = getMinMax(bedsMinInt, bedsMaxInt, translations);

    return `${bedsMin}${separator}${bedsMax}${minMax}`;
};
